import React, { useState } from 'react';
import styled from 'styled-components';
import Card from '../../atoms/Card';
import CardTitle from '../../atoms/CardTitle';
import CardSubtitle from '../../atoms/CardSubtitle';
import SelectField from '../../atoms/SelectField'; // adjust path as needed
import {
    ATELIERREUNION,
    ATELIERBILAN,
    ATELIEREMOTION,
    ATELIERPOID,
    ATELIERPHYSIQUE,
    ATELIERMANUELLE,
    ATELIERTNS,
    ATELIERPAIRS
  } from '../../../constants/images';



// Styled Components
const PageWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  padding-top: 0px; // Adjust based on your navbar height
  padding-bottom: 35px;
`;

const PageContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2px 0px;
`;

const PageTitle = styled.h1`
  text-align: center;
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 25px;
  padding-top: 0px;
`;

const WorkshopsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
  padding-bottom: 48px;
  
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const WorkshopImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 20px;
  margin-bottom: 16px;
`;

const ObjectiveTitle = styled.p`
  font-weight: bold;
  margin-bottom: 8px;
`;

const ObjectiveText = styled.p`
  color: #4b5563;
  margin-bottom: 16px;
  line-height: 1.5;
`;

const ReadMoreLink = styled.a`
  display: inline-block;
  padding: 8px 16px;
  background-color: #f3f4f6;
  color: #4b5563;
  border-radius: 6px;
  text-decoration: none;
  transition: background-color 0.2s;
  margin-bottom: 16px;
  
  &:hover {
    background-color: #e5e7eb;
  }
`;

const SelectWrapper = styled.div`
  margin-top: 16px;
`;

const Select = styled.select`
  width: 100%;
  padding: 8px;
  margin: 12px 0;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background-color: white;
`;

const BookButton = styled.a`
  display: inline-block;
  padding: 12px 24px;
  background-color: #cdebf3;
  color: black;
  border-radius: 6px;
  text-decoration: none;
  transition: background-color 0.2s;
  margin-top: 8px;
  
  &:hover {
    background-color: rgb(175, 230, 245);
  }
`;

const ButtonWrapper = styled.div`
  text-align: center;
  margin-top: 16px;
`;

const CardContent = styled.div`
  padding: 16px;
`;

const Reservation = () => {

  const workshops = [
    {
      id: 'reunion',
      title: "Réunion d'information générale",
      image: ATELIERREUNION,
      objective: "Découvrir le programme TABAPSY et ses différents ateliers. Cette séance permet de comprendre les aides disponibles pour l'arrêt du tabac et de poser toutes vos questions sur le programme.",
      readMoreLink: "https://tabapsy.fr/ateliers/reunion"
    },
    {
      id: 'bilan',
      title: "Atelier de bilan",
      image: ATELIERBILAN,
      objective: "Réaliser un bilan personnalisé de votre consommation de tabac, évaluer votre niveau de dépendance et définir ensemble votre stratégie d'arrêt ou de réduction adaptée à votre situation.",
      readMoreLink: "https://tabapsy.fr/ateliers/bilan"
    },
    {
      id: 'traitements',
      title: "Atelier TNS et cigarette électronique",
      image: ATELIERTNS,
      objective: "Comprendre les différents traitements nicotiniques de substitution (TNS) et la cigarette électronique. Découvrir les aides médicamenteuses disponibles et apprendre à les utiliser efficacement pour réussir votre sevrage.",
      readMoreLink: "https://tabapsy.fr/ateliers/traitements"
    },
    {
      id: 'emotions',
      title: "Atelier gestion des émotions",
      image: ATELIEREMOTION,
      objective: "Apprendre à gérer le stress, l'anxiété et les émotions difficiles sans avoir recours à la cigarette. Découvrir des techniques de relaxation et de gestion émotionnelle pour mieux vivre votre sevrage tabagique.",
      readMoreLink: "https://tabapsy.fr/ateliers/emotions"
    },
    {
      id: 'poid',
      title: "Atelier prise de poids",
      image: ATELIERPOID,
      objective: "Comprendre et anticiper les changements liés à l'arrêt du tabac sur votre poids. Apprendre à adopter une alimentation équilibrée et des habitudes saines pour maintenir votre poids pendant le sevrage tabagique.",
      readMoreLink: "https://tabapsy.fr/ateliers/poid"
    },
    {
      id: 'activites-physiques',
      title: "Atelier activités physiques",
      image: ATELIERPHYSIQUE,
      objective: "Découvrir comment l'activité physique peut vous aider dans votre démarche d'arrêt du tabac. Pratiquer des exercices adaptés à votre niveau et apprendre à intégrer l'activité physique dans votre quotidien.",
      readMoreLink: "https://tabapsy.fr/ateliers/activites-physiques"
    },
    {
      id: 'activites-manuelles',
      title: "Atelier activités manuelles",
      image: ATELIERMANUELLE,
      objective: "Explorer différentes activités manuelles et créatives pour occuper vos mains et votre esprit pendant le sevrage tabagique. Ces activités vous aideront à gérer les envies de fumer et à développer de nouveaux centres d'intérêt.",
      readMoreLink: "https://tabapsy.fr/ateliers/activites-manuelles"
    },
    {
      id: 'soutien-pairs',
      title: "Groupe de soutien entre pairs",
      image: ATELIERPAIRS,
      objective: "Échanger avec d'autres personnes qui vivent la même expérience que vous. Partager vos difficultés, vos succès et vos stratégies dans un cadre bienveillant et encourageant. Le groupe permet de se sentir moins seul et de trouver du soutien dans votre démarche.",
      readMoreLink: "https://tabapsy.fr/ateliers/soutien-pairs"
    }
  ];

  const cmpOptions = [
    { id: 'cmp1', text: 'CMP de Lillers' },
    { id: 'cmp2', text: 'CMP de Noeux les mines' },
    { id: 'cmp3', text: 'EPSM des Flandres (CMP de Bailleul, Merville et Hazebrouck)' },
    { id: 'cmp4', text: '94G16 : CMP Mary Barnes-Charenton et Lilas-Alfortville' },
    { id: 'cmp5', text: 'Paris 11 : CMP République et CMP Servan' },
    { id: 'cmp6', text: 'CMP Turbigo' },
    { id: 'cmp7', text: 'CMP Figuier' },
    { id: 'cmp8', text: 'CMP de Nanterre et de Courbevoie du CASH de Nanterre' },
    { id: 'cmp9', text: 'CH Rouffach (CMP de Thann, Guebwiller, Pfastatt, Pavillon 11 à Rouffach)' },
    { id: 'cmp10', text: 'CMP de Bouillante' },
    { id: 'cmp11', text: 'CMP de Basse Terre' }
  ];

  const doodleLinks = {
    cmp1: {
      "reunion": "https://doodle.com/sign-up-sheet/participate/ac3d9982-b0ba-4aa7-b8fd-81037127a100/select",
      "bilan": "https://doodle.com/sign-up-sheet/participate/8ba06253-75ce-4f1a-9f80-603833409c02/select",
      "traitements": "https://doodle.com/sign-up-sheet/participate/730a6404-1622-4779-8400-64a5718d9a5c/select",
      "emotions": "https://doodle.com/sign-up-sheet/participate/37fc9643-d436-48a7-ab19-ee97d6164ca9/select",
      "poid": "https://doodle.com/sign-up-sheet/participate/f1507bf3-6357-4d01-bc35-b9775a07b96a/select",
      "activites-physiques": "https://doodle.com/sign-up-sheet/participate/e15b9496-ef59-453f-9ba1-39fa71dd3682/select",
      "activites-manuelles": "https://doodle.com/sign-up-sheet/participate/527973fe-cc36-4c44-814a-c3bd992dafef/select",
      "soutien-pairs": "https://doodle.com/sign-up-sheet/participate/e6e2d2b7-17d2-4095-841b-360c9c463b6d/select"
    },
    cmp2: {
     "reunion": "https://doodle.com/sign-up-sheet/participate/06716d21-f40c-4e24-9a11-92b1da3fee3f/select",
    "bilan": "https://doodle.com/sign-up-sheet/participate/44ffca21-7dbe-46d5-99b2-930abc647aa2/select",
    "traitements": "https://doodle.com/sign-up-sheet/participate/5d02064b-a558-431e-bb48-1feaae3f5c7f/select",
    "emotions": "https://doodle.com/sign-up-sheet/participate/49f01996-8890-44f2-9a2c-3c31933932b6/select",
    "poid": "https://doodle.com/sign-up-sheet/participate/4b337ec9-c3a4-4db2-9918-04fd6d844b6b/select",
    "activites-physiques": "https://doodle.com/sign-up-sheet/participate/ca0d6aff-18a8-4276-9f3a-7fb464c17937/select",
    "activites-manuelles": "https://doodle.com/sign-up-sheet/participate/63e6b7a7-ff6c-43bc-99c2-257bd006ce4e/select",
    "soutien-pairs": "https://doodle.com/sign-up-sheet/participate/226e1e69-9d28-4a5f-9b59-9f7aa19f8aae/select"
    },
    cmp3: {
      "reunion": "https://doodle.com/sign-up-sheet/participate/d148be0c-08a7-45fa-a9e2-71606bbf69ae/select",
      "bilan": "https://doodle.com/sign-up-sheet/participate/60a4fe6a-6cd8-4bd2-9bf1-340fcb3aabff/select",
      "traitements": "https://doodle.com/sign-up-sheet/participate/9d9b6ec9-2044-4890-8cd0-78de489fb494/select",
      "emotions": "https://doodle.com/sign-up-sheet/participate/ab985cee-518c-41cc-aff4-40af8006a0dc/select",
      "poid": "https://doodle.com/sign-up-sheet/participate/0297c7db-db31-4e9a-82c0-012371406f30/select",
      "activites-physiques": "https://doodle.com/sign-up-sheet/participate/5db21d98-98c7-49de-ad56-a4aa449b1c7d/select",
      "activites-manuelles": "https://doodle.com/sign-up-sheet/participate/c17b6478-28e2-42fa-a0ce-efdd263375a1/select",
      "soutien-pairs": "https://doodle.com/sign-up-sheet/participate/8ae6f1b9-1a9c-493b-b86f-16207e47f4a4/select"
    },
    cmp4: {
      "reunion": "https://doodle.com/sign-up-sheet/participate/5c1b8af3-f393-4b4b-b9d3-9f2f77902301/select",
      "bilan": "https://doodle.com/sign-up-sheet/participate/f96acc43-7457-4290-bd51-8592665ddb1f/select",
      "traitements": "https://doodle.com/sign-up-sheet/participate/7120f947-6108-4661-9877-ed2e77743705/select",
      "emotions": "https://doodle.com/sign-up-sheet/participate/e829212b-71ad-471e-85a4-eff3378874bc/select",
      "poid": "https://doodle.com/sign-up-sheet/participate/2819a90e-d271-479a-bd5d-e5c127ce63e0/select",
      "activites-physiques": "https://doodle.com/sign-up-sheet/participate/9320aefc-4d76-4bca-a7cc-4acf4004c7c9/select",
      "activites-manuelles": "https://doodle.com/sign-up-sheet/participate/c2a570e0-8f08-4d3e-9d12-ad403d86faca/select",
      "soutien-pairs": "https://doodle.com/sign-up-sheet/participate/453e617d-4cbb-41ac-ad2d-c4c87c76cbd3/select"
    },
    cmp5: {
      "reunion": "https://doodle.com/sign-up-sheet/participate/0f78562c-1cdf-40fb-a9b9-2c5b3f9c2443/select",
      "bilan": "https://doodle.com/sign-up-sheet/participate/0f99f13d-6d63-4089-9edc-199315f393fb/select",
      "traitements": "https://doodle.com/sign-up-sheet/participate/80b103fe-6d07-4b29-806e-fa0ce1f26c59/select",
      "emotions": "https://doodle.com/sign-up-sheet/participate/6f95f44b-7766-41a1-ae46-52c3e9965b39/select",
      "poid": "https://doodle.com/sign-up-sheet/participate/c8903ae8-99b0-40d6-b91f-4050a64819b0/select",
      "activites-physiques": "https://doodle.com/sign-up-sheet/participate/451b423a-7766-402a-8875-999a45af016c/select",
      "activites-manuelles": "https://doodle.com/sign-up-sheet/participate/62bca99c-2ab6-4d39-be7e-764e513c71af/select",
      "soutien-pairs": "https://doodle.com/sign-up-sheet/participate/dd557136-93be-4fc0-bc87-5a19f1429cfc/select"
    },
    cmp6: {
      "reunion": "https://doodle.com/sign-up-sheet/participate/4c4e7341-1e75-458c-9d9e-1aeac4455aac/select",
      "bilan": "https://doodle.com/sign-up-sheet/participate/fff613fb-ac2b-4017-833d-e90dd023a282/select",
      "traitements": "https://doodle.com/sign-up-sheet/participate/57bb96e3-f4fd-4203-adc9-03ac021ab2b4/select",
      "emotions": "https://doodle.com/sign-up-sheet/participate/c24366c5-09d6-49d9-a5f8-73b93a09d2f5/select",
      "poid": "https://doodle.com/sign-up-sheet/participate/ba54cdfd-3242-4b7f-903e-35c9409da5b5/select",
      "activites-physiques": "https://doodle.com/sign-up-sheet/participate/7782029c-f35c-45cf-abc0-e8a825717c79/select",
      "activites-manuelles": "https://doodle.com/sign-up-sheet/participate/a8610860-e0cb-4023-8b31-cc018db01bb2/select",
      "soutien-pairs": "https://doodle.com/sign-up-sheet/participate/d4ec7dd0-5d56-46ce-9ee6-f2feeda22527/select"
    },
    cmp7: {
      "reunion": "https://doodle.com/sign-up-sheet/participate/9756e957-2fcf-41ff-bd6c-47d0c9061eab/select",
      "bilan": "https://doodle.com/sign-up-sheet/participate/80fc46ed-2f4d-4dec-b412-0a5adb73fb3c/select",
      "traitements": "https://doodle.com/sign-up-sheet/participate/283a803b-0413-45f5-81cc-d873ac2d9fd3/select",
      "emotions": "https://doodle.com/sign-up-sheet/participate/03ded9f1-5c1f-45dd-8865-c8fc4e33b26e/select",
      "poid": "https://doodle.com/sign-up-sheet/participate/f1bf7212-871f-4f4a-884a-e96656d5bcaf/select",
      "activites-physiques": "https://doodle.com/sign-up-sheet/participate/8f664ec2-02e4-4a9c-869a-9fc42be4b3cf/select",
      "activites-manuelles": "https://doodle.com/sign-up-sheet/participate/e44b5cdd-e8aa-4885-9380-1953b083bfe3/select",
      "soutien-pairs": "https://doodle.com/sign-up-sheet/participate/9bf632a8-671c-491d-b245-39297034852f/select"
    },
    cmp8: {
      "reunion": "https://doodle.com/sign-up-sheet/participate/7f350fc1-3438-4ecc-8384-e34b84312435/select",
      "bilan": "https://doodle.com/sign-up-sheet/participate/cfb05db5-6b4b-49b6-ae5c-dee87ed3e54e/select",
      "traitements": "https://doodle.com/sign-up-sheet/participate/585e1d4a-9414-4227-bbfc-8db815a7a94b/select",
      "emotions": "https://doodle.com/sign-up-sheet/participate/3f7c5464-bd96-4cae-a71d-43dc5f543d8d/select",
      "poid": "https://doodle.com/sign-up-sheet/participate/ac4cf4c4-d226-480e-8065-66ca700ff0a5/select",
      "activites-physiques": "https://doodle.com/sign-up-sheet/participate/82001fd8-5588-4037-9a46-046cb45ec5cd/select",
      "activites-manuelles": "https://doodle.com/sign-up-sheet/participate/ec12c176-f4c4-4385-8285-78ffd7555934/select",
      "soutien-pairs": "https://doodle.com/sign-up-sheet/participate/d727e47b-85a1-476e-ab52-c4c21617f324/select"
    },
    cmp9: {
      "traitements": "https://doodle.com/sign-up-sheet/participate/d8deb25d-b799-40c4-8612-8a6dab8d1eb3/select",
      "emotions": "https://doodle.com/sign-up-sheet/participate/01c111cd-b020-4975-a6ef-4e52f4fc4816/select",
      "poid": "https://doodle.com/sign-up-sheet/participate/bf2de42e-0f1a-46c0-b6a2-eafa75c3e598/select",
      "soutien-pairs": "https://doodle.com/sign-up-sheet/participate/dd6b54c2-19a0-47e0-80eb-7f725de458c7/select"
    },
    cmp10: {
      "traitements": "https://doodle.com/sign-up-sheet/participate/ced4558c-4cc2-42cf-9ce4-bdca3bf30496/select",
      "emotions": "https://doodle.com/sign-up-sheet/participate/cb3229f3-b2cb-4cc9-b392-29895a946380/select",
      "poid": "https://doodle.com/sign-up-sheet/participate/6e565436-e04b-44c2-9a14-f3180d6d7c96/select",
      "activites-physiques": "https://doodle.com/sign-up-sheet/participate/90c1b2ab-9d96-4c6b-869e-0f8e0233cbea/select",
      "activites-manuelles": "https://doodle.com/sign-up-sheet/participate/b0aeb167-5a47-4898-97a0-2b002db388d8/select",
      "soutien-pairs": "https://doodle.com/sign-up-sheet/participate/b67dcfc2-0ac8-4da7-813d-1f36738977f3/select"
    },
    cmp11: {
      "traitements": "https://doodle.com/sign-up-sheet/participate/4269fb51-d522-4a52-af3d-4c5b7853ac63/select"
    }
    
  };

  const [selectedCMPs, setSelectedCMPs] = useState({});

  const handleCMPChange = (workshopId, cmpValue) => {
    setSelectedCMPs(prev => ({
      ...prev,
      [workshopId]: cmpValue
    }));
  };

  const WorkshopCard = ({ workshop }) => {
    const selectedCMP = selectedCMPs[workshop.id];
    const doodleLink = selectedCMP && doodleLinks[selectedCMP]?.[workshop.id];

    return (
      <Card>
        <CardContent>
          <WorkshopImage 
            src={workshop.image} 
            alt={workshop.title}
          />
          <CardTitle>{workshop.title}</CardTitle>
          <div>
            <ObjectiveTitle>Objectif :</ObjectiveTitle>
            <ObjectiveText>{workshop.objective}</ObjectiveText>
            <ReadMoreLink href={workshop.readMoreLink}>
              Lire plus
            </ReadMoreLink>
          </div>
          <SelectWrapper>
  {/* <CardSubtitle>Choisissez votre CMP</CardSubtitle> */}
  <SelectField
    value={selectedCMPs[workshop.id] || ''}
    options={cmpOptions}
    placeholder="Sélectionnez un CMP"
    onChange={(val) => handleCMPChange(workshop.id, val)}
  />
  {doodleLink && (
    <ButtonWrapper>
      <BookButton
        href={doodleLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        Réserver un créneau
      </BookButton>
    </ButtonWrapper>
  )}
</SelectWrapper>

        </CardContent>
      </Card>
    );
  };

  return (
    <PageWrapper>
      <PageContainer>
        <PageTitle>
          Réservez des Ateliers de Tabapsy
        </PageTitle>
        
        <WorkshopsGrid>
          {workshops.map(workshop => (
            <WorkshopCard key={workshop.id} workshop={workshop} />
          ))}
        </WorkshopsGrid>
      </PageContainer>
    </PageWrapper>
  );
};

export default Reservation;